import { DependencyList, useCallback, useEffect, useRef, useState } from 'react'

interface UseReturnTrueForXSecondsConfig {
  seconds: number,
  initialValue?: boolean
}

/**
 * On mount, starts a timer that will only return true for the allotted seconds
 * and then trigger a re-render with the return value set to false
 *
 * If dependencies are passed, the counter will reset on dependency changes
 */
export const useReturnTrueForXSeconds = (
  {
    seconds,
    initialValue
  }: UseReturnTrueForXSecondsConfig,
  deps: DependencyList
) => {
  const [returnValue, setReturnValue] = useState(initialValue)

  const doTimeout = useCallback(() => {
    setReturnValue(true)
    setTimeout(() => {
      setReturnValue(false)
    }, seconds * 1000)
  }, [seconds])

  const firstUpdate = useRef(true)
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      if (!initialValue) {
        return
      }
    }
    doTimeout()
  // eslint-disable-next-line react-hooks/exhaustive-deps -- no need for linting on this, this is a custom list
  }, [doTimeout, ...deps])

  return returnValue
}
